var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5962 11.1969V13.9622C13.5962 15.2282 14.6224 16.2544 15.8883 16.2544H18.1456C19.4308 16.2544 20.4726 17.2962 20.4726 18.5814C20.4726 19.8666 19.4308 20.9085 18.1456 20.9085H9.61514M14.8317 4.27067C14.8317 4.9013 14.3205 5.41253 13.6898 5.41253C13.0592 5.41253 12.548 4.9013 12.548 4.27067C12.548 3.64004 13.0592 3.12881 13.6898 3.12881C14.3205 3.12881 14.8317 3.64004 14.8317 4.27067ZM6.26708 15.8879C6.26708 16.6152 5.67755 17.2047 4.95031 17.2047C4.22308 17.2047 3.63354 16.6152 3.63354 15.8879C3.63354 15.1607 4.22308 14.5712 4.95031 14.5712C5.67755 14.5712 6.26708 15.1607 6.26708 15.8879ZM8.90062 15.8879C8.90062 18.0696 6.26708 21.155 4.95031 21.155C3.63354 21.155 1 18.0696 1 15.8879C1 13.7062 2.76861 11.9376 4.95031 11.9376C7.132 11.9376 8.90062 13.7062 8.90062 15.8879ZM17.1155 4.27068C17.1155 6.16258 14.8317 8.83812 13.6899 8.83812C12.548 8.83812 10.2643 6.16258 10.2643 4.27068C10.2643 2.37878 11.798 0.845093 13.6899 0.845093C15.5818 0.845093 17.1155 2.37878 17.1155 4.27068Z",
    stroke: "#3C7795",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.ff5d198789a4214b518e6a303095566e.svg";
export { ForwardRef as ReactComponent };